import React from "react";

const LoaderOverlay = () => (
  <div className="fixed inset-0 bg-black bg-opacity-30 z-50 flex items-center justify-center">
    <div className="w-12 h-12 border-4 border-white border-t-[#00A762] rounded-full animate-spin" />
  </div>
);

export default LoaderOverlay;
